// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"e1320d67","822":"bfeb8655"}[chunkId] + ".chunk.js";
};